// UserBubble.jsx
const UserBubble = ({ message, children }) => {
  const content = message ?? children;
  const displayText =
    typeof content === "string"
      ? content.split("__CHATBOT_NL__").join("\n")
      : content;

  return (
    <div className="relative mr-[12.5px] w-fit max-w-full text-[16px] bg-[#a9a9a9] text-[#2d2d2d] px-3 py-2 rounded-md whitespace-pre-wrap break-words">
      {displayText}
      {/* arrow */}
      <div className="absolute right-[-8px] top-1/2 -translate-y-1/2
                      border-y-[8px] border-y-transparent
                      border-l-[8px] border-l-[#a9a9a9]" />
    </div>
  );
}

export default UserBubble;